// local
import { gtag } from './ga.js';
import parsely from './parsely.ts';

/**
 * Track a user interaction in GA.
 */
export function trackEvent(eventName, eventData = {}) {
  // Convert legacy event format to GA4 format
  if (typeof eventData === 'string') {
    eventData = convertLegacyEvent(...arguments);
    eventName = eventData.event_name;
  }

  try {
    if (process.env.NODE_ENV === 'development') {
      console.info('trackEvent', eventName, eventData);
    } else {
      gtag('event', eventName, eventData);
    }
  } catch (e) {
    console.warn('error reporting event', eventData);
  }
}

/**
 * Convert a Universal analytics style event into GA4 format.
 */
function convertLegacyEvent(
  category,
  action,
  label = '',
  value = undefined,
  _ = {}
) {
  return {
    event_name: `${category}_${action}`,
    event_category: category,
    event_action: action,
    event_label: label,
    event_value: value,
  };
}

/**
 * Track a non-interactive event in GA.
 */
export function trackPassiveEvent(
  category,
  action,
  label = '',
  value = undefined
) {
  const passiveOptions = { nonInteraction: 1 };
  return trackEvent(category, action, label, value, passiveOptions);
}

// Make this available site-wide for graphics
window.TMPAnalytics = window.TMPAnalytics || {};
window.TMPAnalytics.trackConversion = (label) => parsely.trackCustom(label);
window.TMPAnalytics.trackEvent = trackEvent;
// For backwards compatibility with old graphics.
window.report = trackEvent;
